













import Vue from 'vue';
import ProuniStepLayout from '@/components/prouni/ProuniStepLayout.vue';
import ProuniEducationForm from '@/components/forms/prouni/ProuniEducationForm.vue';
import prouniPipeline from '@/pipeline/prouni';
import prouniSteps from '@/pipeline/prouni/steps';
import { ProuniApplication } from '@/store/modules/prouni/types';

export default Vue.extend({
  name: 'ProuniEducationView',
  components: { ProuniStepLayout, ProuniEducationForm },
  data() {
    return {
      form: {} as Partial<ProuniApplication>,
      isValid: false,
      isLoading: false,
      error: false,
    };
  },
  computed: {
    application(): ProuniApplication | null {
      return this.$store.getters.prouniApplication;
    },
  },
  methods: {
    inputHandler(form: Partial<ProuniApplication>, isValid: boolean) {
      this.form = form;
      this.isValid = isValid;
      this.error = false;
    },
    async nextHandler() {
      this.isLoading = true;
      this.error = false;
      try {
        await this.$store.dispatch('UPSERT_PROUNI_APPLICATION', {
          ...this.form,
          pipelineState: { step: prouniSteps.education },
        });
        prouniPipeline.next();
      } catch (err) {
        this.error = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
});
